export default __webpack_public_path__ + "static/media/preview.1f2f56f5.png";